import script from "./Panel.vue?vue&type=script&lang=ts&setup=true"
export * from "./Panel.vue?vue&type=script&lang=ts&setup=true"

import "./Panel.vue?vue&type=style&index=0&id=6aa88b83&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa88b83"]])

export default __exports__